<template>
  <v-navigation-drawer
    :value="value"
    :width="fullWidth ? '100%' : '350px'"
    absolute
    temporary
    @input="$emit('input', $event)"
  >
    <!-- On a phone the drawer covers the screen, so there is no scrim left to tap.
         The close button is how it is dismissed. -->
    <div v-if="fullWidth" class="d-flex justify-end pa-2">
      <v-btn icon aria-label="Close menu" @click="$emit('input', false)">
        <font-awesome-icon icon="times" size="lg" />
      </v-btn>
    </div>
    <sidebar />
  </v-navigation-drawer>
</template>

<script lang="ts">
import Vue from "vue";
import Sidebar from "./Sidebar.vue";

export default Vue.extend({
  name: "AppDrawer",
  components: { Sidebar },
  props: {
    value: { type: Boolean, default: false },
  },
  computed: {
    fullWidth(): boolean {
      // Phones only. smAndDown reaches 960px, which would give a small laptop window
      // a full-screen menu; xsOnly matches the 600px breakpoint used elsewhere.
      return this.$vuetify.breakpoint.xsOnly;
    },
  },
});
</script>
